import { useSeoMeta } from '@unhead/react';

/**
 * Public "Verify Licence" page. This is what the QR code on the digital
 * licence opens: a read-only summary confirming the licence is valid.
 */
const FIELDS: { label: string; value: string }[] = [
  { label: 'Name', value: 'Beau J Sallabank' },
  { label: 'Date of birth', value: '13/09/2006' },
  { label: 'Licence number', value: '74291836' },
  { label: 'Licence type', value: 'Probationary (Car)' },
  { label: 'Expiry', value: '10/08/2027' },
  { label: 'Proficiency', value: 'Car' },
];

const VerifyLicence = () => {
  useSeoMeta({
    title: 'Verify licence — VicRoads',
    description: 'Verify a Victorian digital driver licence.',
  });

  return (
    <div className="min-h-screen w-full bg-[#eef0f3] flex justify-center px-4 py-10">
      <div className="w-full max-w-[420px]">
        <div className="overflow-hidden rounded-2xl bg-white shadow-[0_4px_24px_rgba(26,43,76,0.10)]">
          <div className="flex items-center justify-between bg-[#cc3d2b] px-6 py-5 text-white">
            <div>
              <div className="text-[13px] font-bold tracking-wide">VICTORIAN DRIVER LICENCE</div>
              <div className="mt-0.5 text-[12px] opacity-90">Digital verification</div>
            </div>
            <div className="text-[22px] leading-none">🪪</div>
          </div>

          <div className="border-b border-[#eceff3] px-6 py-8 text-center">
            <span className="inline-flex h-14 w-14 items-center justify-center rounded-full bg-[#4caf50]">
              <svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                <path d="M5 13l4 4L19 7" />
              </svg>
            </span>
            <div className="mt-4 text-[24px] font-extrabold tracking-[-0.3px] text-[#1a2b4c]">Licence verified</div>
            <div className="mt-1 text-[13px] text-[#97a1b3]">This licence is current and valid.</div>
          </div>

          <div className="px-6 py-6">
            <dl className="grid grid-cols-2 gap-x-5 gap-y-6">
              {FIELDS.map((f) => (
                <div key={f.label}>
                  <dt className="text-[12px] text-[#97a1b3]">{f.label}</dt>
                  <dd className="mt-1 text-[16px] font-bold text-[#1a2b4c]">{f.value}</dd>
                </div>
              ))}
            </dl>
          </div>

          <div className="bg-[#eef0f3] px-6 py-5">
            <div className="flex items-center gap-3">
              <span className="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-[#4caf50]">
                <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="#fff" strokeWidth="3.2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M5 13l4 4L19 7" />
                </svg>
              </span>
              <div>
                <div className="text-[16px] font-extrabold text-[#1a2b4c]">Passed at 14:04</div>
                <div className="text-[12px] text-[#97a1b3]">Presented with the owner&rsquo;s consent</div>
              </div>
            </div>
          </div>
        </div>

        <p className="mt-6 text-center text-[12px] text-[#97a1b3]">
          The licence holder consented to sharing this information.
        </p>
        <p className="mt-2 text-center text-[12px] text-[#97a1b3]">
          <a href="https://shakespeare.diy" target="_blank" rel="noreferrer noopener" className="underline">
            Vibed with Shakespeare
          </a>
        </p>
      </div>
    </div>
  );
};

export default VerifyLicence;
